<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>{{unitUuid ? 'edit' : 'add'}}</v-icon>
      </v-btn>
    </template>

    <v-card v-if="!unitUuid && max_units>0 && count_units>=max_units">
      <v-card-text>
        <v-alert v-if="max_units>1" color="blue-grey" :value="true">{{$t('alerts.max-units-exceed')}}</v-alert>
        <v-alert v-else color="blue-grey" :value="true">{{$t('alerts.max-units-exceed-one')}}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn flat @click="dismiss()">
          <v-icon>close</v-icon>Close
        </v-btn>
      </v-card-actions>

    </v-card>
    <v-card v-else>
      <v-card-title>
        <span class="headline">{{!unitUuid ? $t('unit-add') : $t('unit-edit')}}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                v-model="unit.name"
                :label="$t('unit-name')"
                required
                :placeholder="$t('unit-name-placeholder')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="unit.address"
                :label="$t('unit-address')"
                required
                type="number"
              ></v-text-field>
              <v-switch
                v-if="!global_slave"
                v-model="unit.slave"
                :label="$t('unit-subaddress')"
              ></v-switch>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="unit.location"
                :label="$t('unit-location')"
                :placeholder="$t('unit-location-placeholder')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="unit.note"
                :label="$t('unit-note')"
                :placeholder="$t('unit-location-placeholder')"
              ></v-text-field>
            </v-flex>
            <v-alert
              v-if="global_slave"
              :value="true"
              outline
              color="blue-grey"
              icon="info"
              border="left"
              colored-border
            >{{$t('alerts.global-slave')}}</v-alert>

            <v-alert :value="true" type="error" v-if="error">{{error}}</v-alert>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn flat @click="dismiss()">
          <v-icon>close</v-icon>Close
        </v-btn>
        <v-spacer />
        <v-btn flat @click="addUnit">
          <v-icon>{{unitUuid ? 'edit' : 'add'}}</v-icon>
          {{unitUuid ? 'save' : 'add'}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    onSwitchChange(e) {
      console.log(e);
      this.unit.slave = !this.unit.slave;
    },
    getDefaultUnit() {
      return {
        name: "",
        address: "",
        slave: true,
        note: "",
        location: ""
      };
    },
    dismiss() {
      if (this.unitUuid) {
        this.$store.dispatch("duo/units").then(() => {
          this.dialog = false;
        });
      } else {
        this.dialog = false;
        this.unit = this.getDefaultUnit();
        this.error = null;
      }
    },
    addUnit() {
      this.error = null;
      if (this.unitUuid) {
        this.$store
          .dispatch("duo/updateUnit", {
            uuid: this.unitUuid,
            unit: this.unit
          })
          .then(() => {
            this.dialog = false;
          })
          .catch(e => {
            console.warn(e);
            this.error = e.response.data.message || e.message;
          });
      } else {
        this.$store
          .dispatch("duo/addUnit", this.unit)
          .then(() => {
            this.dialog = false;
            this.unit = this.getDefaultUnit();
          })
          .catch(e => {
            console.warn(e);
            this.error = e.response.data.message || e.message;
          });
      }
    }
  },
  props: {
    unitObject: {
      type: Object
    },
    unitUuid: {
      type: String
    }
  },
  computed: {
    ...mapState("info", ["infos"]),
    ...mapState("duo", ["units"]),
    max_units: function() {
      if (!this.infos || !this.infos.limits) return null;
      return this.infos.limits.max_units;
    },
    count_units: function() {
      return Object.keys(this.units).length;
    },
    global_slave: function() {
      return this.infos && this.infos.limits && this.infos.limits.global_slave;
    }
  },
  data() {
    return {
      dialog: false,
      error: null,
      unit: this.unitObject ? this.unitObject : this.getDefaultUnit()
    };
  }
};
</script>

<style>
</style>
